#!/usr/bin/env node

import { main } from './bin'

main(undefined, { '--script-mode': true })
